<template>
   <!-- <LoginOrPayView v-if="!$store.state.userLevel || $store.state.userLevel > 100" vip-text="升级版本权益后<br/>即可查看更多数据及使用更多功能"/> -->
  <div id="fans-analysis">
    <!--有分析数据时--> 
      <!-- <div class="update-time">更新时间：{{ updateTime }}</div> -->
      <div class="analysis-detail">
     <div class="addfans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝增长趋势</div>
      </div>
      <fansAdd :info="info"></fansAdd>
      </template>
      <Blur-image v-else vipText="升级会员，即可查看" class="chart" src="https://s6.bihukankan.com/img/1681436223趋势.png"/>
     </div>

     <div class="likefans">
      <template v-if="isVip">
      <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝兴趣分布</div>
      </div>
      <fansLike :info="fansData.fansPortrait.fansInterestPercentage"></fansLike>
      </template>
      <template v-else>
        <img src="https://s6.bihukankan.com/img/1681436241兴趣.png" alt="">
      </template>
        
     </div>

     <div class="sexfans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝性别分布</div>
      </div>
      <fansSex :info="fansData.fansPortrait.fansSex"></fansSex>
      </template>
        <template v-else>
       <img src="https://s6.bihukankan.com/img/1681436258性别.png" alt="">
        </template>
     </div>

     <div class="agefans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝年龄分布</div>
      </div>
      <fansAge :info="fansData.fansPortrait.fansAgePercentage"></fansAge>
      </template>
      <template v-else>
       <img src="https://s6.bihukankan.com/img/1681436271年龄.png" alt="">
        </template>
     </div>

     <div class="ipfans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝位置分布</div>
      </div>
      <fansIp :info="fansData.fansPortrait.fansCity" :Region="fansData.fansPortrait.fansRegion"></fansIp>
      </template>
      <template v-else>
       <img src="https://s6.bihukankan.com/img/1681436283位置.png" alt="">
        </template>
     </div>

     <div class="cityfans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">城市线分布</div>
      </div>
      <fansCity :info="fansData.fansPortrait.fansCityPercentage"></fansCity>
      </template>
      <template v-else>
       <img src="https://s6.bihukankan.com/img/1681436299城市线.png" alt="">
        </template>
     </div>

     <div class="activefans">
      <template v-if="isVip">
        <div class="title">
        <div class="title_box"></div>
        <div class="text">粉丝活跃度</div>
      </div>
      <fansActive :info="fansData.fansPortrait.fansActivityPercentage"></fansActive>
      </template>
      <template v-else>
       <img src="https://s6.bihukankan.com/img/1681436312活跃.png" alt="">
        </template>
     </div>
      </div>
  </div>
</template>

<script>
import fansLike from './components/fansLink.vue'
import fansSex from './components/fanssex.vue'
import fansAge from './components/fansAge.vue'
import fansIp from './components/fansIp.vue'
import fansCity from './components/fansCity.vue'
import fansActive from './components/fansActive.vue'
import fansAdd from './components/fansAdd.vue'
export default {
  components:{fansAdd,fansLike,fansSex,fansAge,fansIp,fansCity,fansActive},
  props: { fansData: Object , info: Array},
  data() { return {  } },
  computed: {
    isVip: (_this = this) => _this.$store.state.userLevel && _this.$store.state.userLevel <= 96,
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
#fans-analysis {
  img,.chart {
    width: 100%;
    height: 100%;
  }
  .title {
    padding: 17px 0 0 12px;
    display: flex;
    .title_box {
      width: 2px;
      height: 16px;
      background: #2A89F3;
      border-radius: 1px;
      margin-right: 6px;
    }
    .text {
      font-weight: 500;
      font-size: 14px;
    }
  }
  .addfans {
    margin-top: 0.21rem;
    width: 375px;
    height: 295px;
    background-color: #fff;
  }

  .likefans {
    margin-top: 0.21rem;
    width: 375px;
    height: 295px;
    background-color: #fff;
  }

  .sexfans {
    margin-top: 0.21rem;
    width: 375px;
    height:230px;
    background-color: #fff;
  }

  .agefans {
    margin-top: 0.21rem;
    width: 375px;
    height: 256px;
    background-color: #fff;
  }

  .ipfans {
    margin-top: 0.21rem;
    width: 375px;
    height: 370px;
    background-color: #fff;
  }

  .cityfans {
    margin-top: 0.21rem;
    width: 375px;
    height: 247px;
    background-color: #fff;
  }

  .activefans {
    margin-top: 0.21rem;
    width: 375px;
    height: 226px;
    background-color: #fff;
  }
}
</style>